(function () {
  const style = document.createElement('style');
  style.textContent = `
    #cbj-cs-overlay {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.55);
      z-index: 1100;
      align-items: center;
      justify-content: center;
      padding: 16px;
    }
    #cbj-cs-overlay.is-open { display: flex; }
    #cbj-cs-modal {
      background: #fff;
      border-radius: 12px;
      padding: 32px 24px 24px;
      max-width: 520px;
      width: 100%;
      position: relative;
      max-height: 90vh;
      overflow-y: auto;
      font-size: 14px;
      line-height: 1.5;
    }
    #cbj-cs-modal .cbj-cs-close {
      position: absolute;
      top: 14px;
      right: 16px;
      background: none;
      border: none;
      cursor: pointer;
      font-size: 22px;
      line-height: 1;
      color: #555;
      padding: 4px;
    }
    .cbj-cs-title {
      font-size: 15px;
      font-weight: 700;
      margin: 0 0 20px;
      color: #111;
    }
    .cbj-cs-products {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
      gap: 16px;
      margin-bottom: 20px;
      justify-items: center;
    }
    .cbj-cs-item {
      text-align: center;
      width: 100%;
      max-width: 180px;
    }
    .cbj-cs-item a {
      display: block;
      text-decoration: none;
      color: inherit;
    }
    .cbj-cs-item img {
      width: 100%;
      aspect-ratio: 1;
      object-fit: cover;
      border-radius: 6px;
      display: block;
    }
    .cbj-cs-name {
      font-size: 12px;
      margin: 8px 0 4px;
      line-height: 1.4;
      color: #222;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .cbj-cs-price {
      font-size: 14px;
      font-weight: 700;
      margin: 0 0 10px;
      color: #111;
    }
    .cbj-cs-add {
      background: rgb(var(--color-button, 0,0,0));
      color: rgb(var(--color-button-text, 255,255,255));
      border: none;
      border-radius: var(--buttons-radius, 4px);
      padding: 9px 12px;
      font-size: 12px;
      cursor: pointer;
      width: 100%;
    }
    .cbj-cs-add:disabled { opacity: 0.5; cursor: not-allowed; }
    .cbj-cs-footer {
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-top: 1px solid #eee;
      padding-top: 16px;
    }
    .cbj-cs-to-cart {
      display: block;
      width: 100%;
      padding: 13px;
      background: rgb(var(--color-button, 0,0,0));
      color: rgb(var(--color-button-text, 255,255,255));
      border: none;
      border-radius: var(--buttons-radius, 4px);
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      text-align: center;
      text-decoration: none;
      box-sizing: border-box;
    }
    .cbj-cs-continue {
      display: block;
      text-align: center;
      font-size: 13px;
      color: #777;
      cursor: pointer;
      background: none;
      border: none;
      width: 100%;
      text-decoration: underline;
    }
    .cbj-cs-picker-back {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 13px;
      color: #555;
      padding: 0 0 16px;
      display: block;
      text-decoration: underline;
    }
    .cbj-cs-picker-header {
      display: flex;
      gap: 14px;
      align-items: flex-start;
      margin-bottom: 20px;
      padding-bottom: 16px;
      border-bottom: 1px solid #eee;
    }
    .cbj-cs-picker-header img {
      width: 72px;
      height: 72px;
      object-fit: cover;
      border-radius: 6px;
      flex-shrink: 0;
    }
    .cbj-cs-picker-name {
      font-size: 13px;
      font-weight: 600;
      line-height: 1.4;
      margin-bottom: 6px;
      color: #111;
    }
    .cbj-cs-picker-price {
      font-size: 15px;
      font-weight: 700;
      color: #111;
    }
    .cbj-cs-opt-group { margin-bottom: 16px; }
    .cbj-cs-opt-label { font-size: 12px; color: #555; margin-bottom: 8px; }
    .cbj-cs-opt-label strong { color: #111; }
    .cbj-cs-opt-btns { display: flex; flex-wrap: wrap; gap: 6px; }
    .cbj-cs-opt-btn {
      padding: 6px 14px;
      border: 1px solid #ccc;
      border-radius: 4px;
      background: #fff;
      cursor: pointer;
      font-size: 13px;
      line-height: 1;
    }
    .cbj-cs-opt-btn.active { border-color: #111; background: #111; color: #fff; }
    .cbj-cs-picker-atc {
      width: 100%;
      padding: 13px;
      background: rgb(var(--color-button, 0,0,0));
      color: rgb(var(--color-button-text, 255,255,255));
      border: none;
      border-radius: var(--buttons-radius, 4px);
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      margin-top: 20px;
    }
    .cbj-cs-picker-atc:disabled { opacity: 0.5; cursor: not-allowed; }
  `;
  document.head.appendChild(style);

  const overlay = document.createElement('div');
  overlay.id = 'cbj-cs-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'cbj-cs-title');
  overlay.innerHTML = `
    <div id="cbj-cs-modal">
      <button class="cbj-cs-close" aria-label="閉じる">&times;</button>
      <div id="cbj-cs-list-view">
        <p class="cbj-cs-title" id="cbj-cs-title">こちらもいかがですか？</p>
        <div class="cbj-cs-products" id="cbj-cs-list"></div>
        <div class="cbj-cs-footer">
          <a href="/cart" class="cbj-cs-to-cart">カートを見る</a>
          <button class="cbj-cs-continue">買い物を続ける</button>
        </div>
      </div>
      <div id="cbj-cs-picker" style="display:none">
        <button class="cbj-cs-picker-back">← 戻る</button>
        <div class="cbj-cs-picker-header">
          <img id="cbj-cs-picker-img" src="" alt="">
          <div>
            <div class="cbj-cs-picker-name" id="cbj-cs-picker-name"></div>
            <div class="cbj-cs-picker-price" id="cbj-cs-picker-price"></div>
          </div>
        </div>
        <div id="cbj-cs-picker-opts"></div>
        <button class="cbj-cs-picker-atc" id="cbj-cs-picker-atc" disabled>カートに追加</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);

  let pickerProduct = null;
  let pickerSelectedIdx = [];

  overlay.querySelector('.cbj-cs-close').addEventListener('click', closePopup);
  overlay.querySelector('.cbj-cs-continue').addEventListener('click', closePopup);
  overlay.querySelector('.cbj-cs-picker-back').addEventListener('click', showListView);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) closePopup(); });
  document.addEventListener('keyup', (e) => { if (e.key === 'Escape') closePopup(); });

  document.getElementById('cbj-cs-picker-atc').addEventListener('click', function () {
    const variantId = this.dataset.variantId;
    if (!variantId) return;
    addToCart(variantId, this);
  });

  function closePopup() {
    overlay.classList.remove('is-open');
    showListView();
  }

  function showListView() {
    document.getElementById('cbj-cs-list-view').style.display = '';
    document.getElementById('cbj-cs-picker').style.display = 'none';
  }

  function showPickerView() {
    document.getElementById('cbj-cs-list-view').style.display = 'none';
    document.getElementById('cbj-cs-picker').style.display = '';
  }

  function formatMoney(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function esc(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = '追加中...';
    const url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(r => {
      if (r.ok) {
        window.location.reload();
      } else {
        btn.disabled = false;
        btn.textContent = 'カートに追加';
      }
    }).catch(() => {
      btn.disabled = false;
      btn.textContent = 'カートに追加';
    });
  }

  function findPickerVariant() {
    if (!pickerProduct || !pickerProduct.options) return null;
    const opts = pickerProduct.options;
    return (pickerProduct.variants || []).find(v =>
      opts.every((o, i) => v['option' + (i + 1)] === o.values[pickerSelectedIdx[i]])
    );
  }

  function renderPickerOpts() {
    if (!pickerProduct || !pickerProduct.options) return;
    const opts = pickerProduct.options;
    const optsEl = document.getElementById('cbj-cs-picker-opts');
    const atcBtn = document.getElementById('cbj-cs-picker-atc');

    optsEl.innerHTML = opts.map((opt, oi) => `
      <div class="cbj-cs-opt-group">
        <div class="cbj-cs-opt-label">${esc(opt.name)}: <strong>${esc(opt.values[pickerSelectedIdx[oi]])}</strong></div>
        <div class="cbj-cs-opt-btns">
          ${opt.values.map((val, vi) => `<button class="cbj-cs-opt-btn${vi === pickerSelectedIdx[oi] ? ' active' : ''}" data-oi="${oi}" data-vi="${vi}">${esc(val)}</button>`).join('')}
        </div>
      </div>
    `).join('');

    optsEl.querySelectorAll('.cbj-cs-opt-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        pickerSelectedIdx[parseInt(this.dataset.oi)] = parseInt(this.dataset.vi);
        renderPickerOpts();
      });
    });

    const v = findPickerVariant();
    if (v) {
      document.getElementById('cbj-cs-picker-price').textContent = formatMoney(v.price !== undefined ? v.price : pickerProduct.price);
      if (v.featured_image && v.featured_image.src) {
        document.getElementById('cbj-cs-picker-img').src = v.featured_image.src.replace(/(\.[^.?]+)(\?|$)/, '_400x400$1$2');
      }
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? 'カートに追加' : '売り切れ';
      atcBtn.dataset.variantId = v.id;
    } else {
      atcBtn.disabled = true;
      atcBtn.textContent = '選択してください';
      delete atcBtn.dataset.variantId;
    }
  }

  function openPicker(p) {
    pickerProduct = p;
    pickerSelectedIdx = (p.options || []).map(() => 0);
    document.getElementById('cbj-cs-picker-img').src = p.image || '';
    document.getElementById('cbj-cs-picker-img').alt = p.image_alt || p.title || '';
    document.getElementById('cbj-cs-picker-name').textContent = p.title || '';
    document.getElementById('cbj-cs-picker-price').textContent = formatMoney(p.price);
    renderPickerOpts();
    showPickerView();
  }

  function showPopup(products) {
    showListView();
    const list = document.getElementById('cbj-cs-list');
    list.innerHTML = products.map((p, idx) => `
      <div class="cbj-cs-item">
        <a href="${esc(p.url)}">
          ${p.image ? `<img src="${esc(p.image)}" alt="${esc(p.image_alt)}" loading="lazy">` : ''}
          <p class="cbj-cs-name">${esc(p.title)}</p>
        </a>
        <p class="cbj-cs-price">${formatMoney(p.price)}</p>
        <button class="cbj-cs-add" data-idx="${idx}" ${p.available ? '' : 'disabled'}>
          ${p.available ? 'カートに追加' : '売り切れ'}
        </button>
      </div>
    `).join('');

    list.querySelectorAll('.cbj-cs-add:not([disabled])').forEach(btn => {
      btn.addEventListener('click', function () {
        const p = products[parseInt(this.dataset.idx)];
        if (!p) return;
        if (p.has_only_default_variant) {
          addToCart(p.variant_id, this);
        } else {
          openPicker(p);
        }
      });
    });

    overlay.classList.add('is-open');
  }

  function tryShow(variantId) {
    const vid = String(variantId);
    const dataEl = document.querySelector(`.cbj-cross-sell-data[data-variant-ids*="${vid}"]`);
    if (!dataEl) return false;
    try {
      const data = JSON.parse(dataEl.textContent);
      if (data.products && data.products.length > 0) {
        showPopup(data.products);
        return true;
      }
    } catch (e) {
      console.error('CBJ cross-sell parse error', e);
    }
    return false;
  }

  window.cbjCrossSell = { tryShow };

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'product-form') return;
      tryShow(event.productVariantId);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    const vid = sessionStorage.getItem('cbj_cs_vid');
    if (vid && window.location.pathname === '/cart') {
      sessionStorage.removeItem('cbj_cs_vid');
      setTimeout(() => tryShow(vid), 300);
    }
  });
})();
